import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/cities/countries', { params })
  },
  store (formData) {
    return apiClient.post('/cities/countries', formData)
  },
  show (id, params) {
    return apiClient.get(`/cities/countries/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/cities/countries/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/cities/countries/${id}`)
  }
}
